// Withings session handling — pre-Tier-4 auth helpers.
//
// Today (localhost dev) the session key is set via the profile menu in the
// UI, stored in localStorage under 'access_session_key'.
// Future (corp vhost) the `*.corp.withings.com` parent-domain cookie set by
// account login is carried by the browser; `getSessionKey()` returns null
// and the wiservice package reads the cookie server-side. No code change
// needed for the migration.

export function getSessionKey(): string | null {
  return localStorage.getItem('access_session_key');
}

/** Write the dev-mode session key to localStorage. Called by the UI's
 *  profile menu "Update session key" modal. Retires when the legacy modal
 *  goes away. */
export function setSessionKey(key: string): void {
  localStorage.setItem('access_session_key', key);
}

// On a *.withings.com host, omit `sessionid` so scalews uses the parent-domain
// cookie — a stale localStorage sessionid would OVERRIDE the cookie and trigger
// the "userid/deviceid... do not match" error.
export function authSessionParams(): Record<string, string> {
  const host = window.location.hostname;
  if (host.endsWith('.withings.com')) return {};
  const sessionid = getSessionKey();
  return sessionid ? { sessionid } : {};
}
